import React, { useMemo } from "react"
import classNames from "utils/classNames"
import isNew, { ToleranceUnit } from "utils/is-new"
import CustomTag, { CustomTagProps } from "./CustomTag"

interface NewTagProps extends CustomTagProps {
  /**
   * The timestamp of the newly created object
   */

  createdAt: string | null
  /**
   * The amount of days after the creation to consider the object new
   * eg. a tolerance of 7 will mean that the object is new event after 7 days since its
   * creation
   * @default 7
   */
  tolerance?: number
  /**
   * The text to display as a new object
   * @default "New!"
   */

  /**
   * @description The unit of time to use for the tolerance
   * @default "days"
   */
  toleranceUnit?: ToleranceUnit
  text?: string
}
const NewTag = ({
  className,
  createdAt,
  text,
  tolerance = 7,
  toleranceUnit = "days",
  ...otherProps
}: NewTagProps) => {
  const isObjNew = useMemo(
    () => isNew(createdAt, tolerance, toleranceUnit),
    [createdAt, tolerance, toleranceUnit]
  )
  return (
    <>
      {isObjNew && createdAt && (
        <CustomTag
          className={classNames("ml-3", className)}
          minimal
          intent="success"
          round
          {...otherProps}
        >
          {text}
        </CustomTag>
      )}
    </>
  )
}

NewTag.defaultProps = {
  text: "New!",
}
export default NewTag
